function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "navigation_previous");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grafill__Sumbission_1.Kategori_list_item_hover",
  transform: "translate(-550.000000, -871.000000)",
  stroke: "#59CB9B",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "bottom_nav",
  transform: "translate(0.000000, 844.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "navigation",
  transform: "translate(551.000000, 21.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "navigation_previous",
  transform: "translate(0.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "previous_btn",
  transform: "translate(0.500000, 0.500000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: 9,
  x2: 8.21110255,
  y2: 19.8166538,
  id: "Line-3",
  strokeLinejoin: "bevel",
  transform: "translate(4.605551, 14.408327) rotate(-11.309932) translate(-4.605551, -14.408327) "
}), /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: 1,
  x2: 8.22649881,
  y2: 11.8397482,
  id: "Line-3",
  strokeLinejoin: "round",
  transform: "translate(4.613249, 6.419874) scale(-1, 1) rotate(-11.309932) translate(-4.613249, -6.419874) "
})))))));

var SvgNavigationPrevious = function SvgNavigationPrevious(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "24px",
    viewBox: "0 0 13 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavigationPrevious, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/navigation_previous.4459b315.svg";
export { ForwardRef as ReactComponent };